import * as svg from "../../../assets/email-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const EmailIcon = iconBuilder(svg, "EmailIcon", "0 0 14 14");
